import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchmealPlanSummary = async ({
  coachId,
  recipeIds,
  mealType,
}) => {
  try {
    const response = await axiosInstance.post(
      `${Endpoints.FETCH_MEAL_PLAN_SUMMARY}/${coachId}?mealType=${mealType}`,
      recipeIds
    );
    return response?.data;
  } catch (error) {
    throw new Error(error.response?.data || "Failed to fetch plan summary");
  }
};
